import 'whatwg-fetch';
import {history} from '../../router/history';
import {
    setTransferStudent,
    add_msg
} from '../../actions'
import fetchConfig from '../fetchConfig'
import SystemModal from '../SystemModal/SystemModal'
import fetchExtend from '../fetchExtend'


export default {
    edit: (dispatch) => {
        SystemModal.showLoadMsg(dispatch)
        fetch(API_SERVER+'/api/v1/transfer_students/0/edit', {
            credentials: 'same-origin',
            method: 'GET',
            headers:  new fetchConfig().fetchConfigHeaders()
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((json) => {
                SystemModal.closeMsg(dispatch)
                dispatch(setTransferStudent(json))
                // dispatch(hideSpinner());
            })
            .catch(function (error) {
                SystemModal.showLoadErrorMsg(dispatch)
            });
    },
    update: (dispatch,payload) => {
        SystemModal.showSaveMsg(dispatch)
        let payloadValue = payload.toJS();
        if (payloadValue.ques_check) {
            SystemModal.closeMsg(dispatch)
            dispatch(add_msg('學生輔導紀錄資料已鎖定，請聯繫註冊組開啟後再修改', 'error'))
            return
        }
        console.log(JSON.stringify(payloadValue))
        let formData = new FormData();
        for (var key in payloadValue){
            formData.append("transfer_student[" + key + "]", payloadValue[key]);
        }
        fetch(API_SERVER+'/api/v1/transfer_students/0.json', {
            credentials: 'same-origin',
            method: 'PATCH',
            headers:  new fetchConfig().fetchConfigHeaders(),
            body: formData
            // body: JSON.stringify( { transfer_student: payloadValue } )
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((json) => {
                SystemModal.closeMsg(dispatch)
                dispatch(add_msg('儲存完成'));
                history.push('/devise_dashboard');

            })
            .catch(function (error) {
                SystemModal.showSaveErrorMsg(dispatch)
            });
    },


}



// WEBPACK FOOTER //
// ./src/dashboards_redux/utils/TransferStudent/TransferStudent.jsx